export class NavigationView {
  constructor(
    public Id: any,
    public Name: string) { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/navigation-view.ts